import { Availability } from '../Availability'
import { Options } from '../Options'

export const tooltipOptions = Options.asRecord(
  Availability.options.disabled,
  Options.createNested({
    key: '_tooltip',
    label: 'Tooltip',
    description: 'Tooltip availability and display options.',
    category: 'Tooltip',
  }),
)

export type TooltipOptions = Options.TypeOf<typeof tooltipOptions>
